import { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';

// Manager self-service onboarding ("Yönetici Paneli / Ekibimin İşe Alıştırması").
// Relationship-scoped against /v1/my-team/onboardings — the backend pins every
// query to the caller's team (ManagerEmployeeId / BuddyEmployeeId), so no OB
// module grant is needed and a non-manager simply sees an empty list.
export default function useMyTeamOnboardingApi() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refresh = useCallback(() => setRefreshTrigger((p) => p + 1), []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get('/v1/my-team/onboardings')
      .then((res) => {
        if (cancelled) return;
        const data = res?.data?.data;
        setRows(Array.isArray(data) ? data : []);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshTrigger]);

  // Read-only detail: onboarding summary + task checklist + chronology (event
  // stream: period approvals, 1:1s, extension, close/cancel with reasons —
  // customer feedback 2026-08). Ownership is enforced server-side (404 if the
  // onboarding isn't on the caller's team).
  const getDetail = useCallback(async (id) => {
    const [detailRes, tasksRes, timelineRes] = await Promise.all([
      api.get(`/v1/my-team/onboardings/${id}`),
      api.get(`/v1/my-team/onboardings/${id}/tasks`),
      api.get(`/v1/my-team/onboardings/${id}/timeline`),
    ]);
    const detail = detailRes?.data?.data || null;
    const tasksData = tasksRes?.data?.data;
    const tasks = Array.isArray(tasksData) ? tasksData : (tasksData?.data || []);
    const timeline = timelineRes?.data?.data || [];
    return { detail, tasks, timeline };
  }, []);

  // OBB-09 — görev onayı/reddi. Uçlar yönetici panelinin KENDİ rotası altında
  // ([Authorize]-only, ilişki kapsamlı): modül uçları (/v1/onboarding-tasks/...)
  // OB.Write ister ve yöneticide o yetki yoktur. Sahiplik sunucuda ekibe
  // sabitlenir (aksi 404), imza yetkisi ise ObTaskService içindeki tek kapıdan
  // geçer (mentör 403 alır).
  const approveTask = useCallback(async (onboardingId, taskId, note) => {
    try { await api.post(`/v1/my-team/onboardings/${onboardingId}/tasks/${taskId}/approve`, { note: note || null }); return true; }
    catch { return false; }
  }, []);

  const rejectTask = useCallback(async (onboardingId, taskId, note) => {
    try { await api.post(`/v1/my-team/onboardings/${onboardingId}/tasks/${taskId}/reject`, { note }); return true; }
    catch { return false; }
  }, []);

  return { loading, rows, refresh, getDetail, approveTask, rejectTask };
}
